import { Box, Chip, Paper, Stack, Typography } from "@mui/material";

import { fmtDMY, ymdToDate } from "../../lienzo_de_trabajo/utils/lienzoUtils";

const MONEY_FORMATTER = new Intl.NumberFormat("es-AR", {
  style: "currency",
  currency: "ARS",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

function formatPeriodDate(value) {
  return value ? fmtDMY(ymdToDate(value)) : "-";
}

function Stat({ label, value, color }) {
  return (
    <Box sx={{ minWidth: { xs: 0, sm: 125 } }}>
      <Typography sx={{ fontSize: 11, fontWeight: 800, color: "neutral.600" }}>
        {label}
      </Typography>
      <Typography
        sx={{
          fontSize: { xs: 14, sm: 17 },
          fontWeight: 900,
          color,
          whiteSpace: "nowrap",
        }}
      >
        {MONEY_FORMATTER.format(Number(value || 0))}
      </Typography>
    </Box>
  );
}

export default function CierreReportHeader({ period, summary }) {
  const totalIncome = Number(summary?.totalIncome ?? period?.totalIncome ?? 0);
  const totalExpense = Number(summary?.totalExpense ?? period?.totalExpense ?? 0);
  const balance = totalIncome - totalExpense;

  return (
    <Stack
      direction={{ xs: "column", lg: "row" }}
      spacing={1.2}
      alignItems={{ xs: "stretch", lg: "center" }}
      justifyContent="space-between"
      sx={{ mb: 1.5 }}
    >
      <Box
        sx={{
          px: { xs: 1.4, sm: 1.8 },
          py: 1.2,
          borderRadius: "16px",
          bgcolor: "rgba(244, 245, 251, 0.88)",
          border: "1px solid rgba(255,255,255,0.8)",
          boxShadow: "inset 0px 0px 4px rgba(117, 117, 138, 0.18)",
        }}
      >
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontSize: 11, fontWeight: 800, color: "neutral.600", mb: 0.2 }}>
              Cierre seleccionado
            </Typography>
            <Typography sx={{ fontSize: 15, fontWeight: 900, color: "primary.900" }}>
              Cierre {formatPeriodDate(period?.periodStart)} - {formatPeriodDate(period?.periodEnd)}
            </Typography>
          </Box>
          <Chip
            label="Completado"
            size="small"
            sx={{
              flexShrink: 0,
              borderRadius: "999px",
              bgcolor: "rgba(185, 246, 202, 0.72)",
              color: "primary.900",
              fontSize: 12,
              fontWeight: 900,
            }}
          />
        </Stack>
      </Box>

      <Paper
        elevation={0}
        sx={{
          px: { xs: 1.5, sm: 2 },
          py: 1,
          borderRadius: "16px",
          border: "1px solid rgba(117, 117, 138, 0.45)",
          bgcolor: "rgba(255,255,255,0.9)",
        }}
      >
        <Stack
          direction="row"
          spacing={{ xs: 1.5, sm: 3 }}
          justifyContent={{ xs: "space-between", lg: "flex-end" }}
        >
          <Stat label="Ingresos" value={totalIncome} color="#159251" />
          <Stat label="Egresos" value={totalExpense} color="#c91f1f" />
          <Stat label="Saldo" value={balance} color={balance < 0 ? "#c91f1f" : "#159251"} />
        </Stack>
      </Paper>
    </Stack>
  );
}
